import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { ThemedLazySkeleton } from '@atlassian/jira-project-theme-components/src/ui/ThemedLazySkeleton.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { jiraBusinessCalendarCustomEmbedRoute } from '@atlassian/jira-router-routes-business-calendar-routes/src/jiraBusinessCalendarCustomEmbedRoute.tsx';
import { createChromelessEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { themePreferenceResource } from '@atlassian/jira-router-resources-theme-preference/src/controllers/resource-erai-1615-old/index.tsx';
import { calendarEntryPoint } from '@atlassian/jira-spa-apps-business-calendar-new/entrypoint.tsx';

const calendarEmbedPageEntrypoint = createChromelessEntryPoint({
	main: calendarEntryPoint,
});

export const jiraBusinessCalendarCustomEmbedRouteEntry = createEntry(
	jiraBusinessCalendarCustomEmbedRoute,
	() => ({
		group: 'classic-business',
		ufoName: 'jwm.calendar-embed-view',

		entryPoint() {
			return calendarEmbedPageEntrypoint;
		},

		layout: chromelessLayout,
		skeleton: ThemedLazySkeleton,
		resources: [themePreferenceResource],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-business-calendar-entries/src/jiraBusinessCalendarCustomEmbedRouteEntry.tsx',
				whichExportToUse: 'jiraBusinessCalendarCustomEmbedRouteEntry',
			},

			enabled: true,
		},
	}),
);
